import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "subject"]
  static values = { firstName: String, lastName: String, company: String }

  trigger(e) {
    // Sample data of body
    this._sampleData(this.bodyTarget.querySelectorAll(".template-attribute"), e.currentTarget.checked)

    // Sample data of subject
    this._sampleData(this.subjectTarget.querySelectorAll(".template-attribute"), e.currentTarget.checked)
  }


  _sampleData(elements, state) {
    let tagClasses = ["template-attribute", "tag"]

    if (state) {
      tagClasses.push("tag--info")
    }

    elements.forEach(element => {
      element.classList = tagClasses.join(" ")

      if (state) {
        element.dataset.original = element.textContent

        if (element.textContent === "{{first_name}}") {
          element.textContent = this.firstNameValue
        } else if (element.textContent === "{{last_name}}") {
          element.textContent = this.lastNameValue
        } else if (element.textContent === "{{company}}") {
          element.textContent = this.companyValue
        }
      } else {
        element.textContent = element.dataset.original
      }
    })
  }
}
